import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";

import { useGenericExportOperation } from "../../controls/forms/buttons/use-generic-export-operation";
import { IBulkActionItem } from "./bulk-actions.models";

/**
 * The "Export CSV/Excel" row is identical in every bulk drawer - build it once here and
 * spread it into the drawer's action list.
 */
export const useGenericExportBulkAction = (): IBulkActionItem => {
  const { t } = useTranslation();
  const { hasPermissionAllowExport, openGenericExportDrawer } =
    useGenericExportOperation();

  return {
    key: "exportCsvExcel",
    label: t(`general.EXPORT_CSV_EXCEL`),
    hint: t(`general.EXPORT_CSV_EXCEL_HINT`),
    icon: PIC.DownloadSVG,
    isHidden: !hasPermissionAllowExport,
    onClick: openGenericExportDrawer,
  };
};
